import { BlockStack, Card, Divider, Grid, InlineStack, Page, SkeletonBodyText, SkeletonDisplayText, SkeletonTabs, SkeletonThumbnail } from '@shopify/polaris';
import React from 'react';
import styles from '../css/overview.module.css';

const OverviewSkeleton = () => {
    return (
        <Page>
            <BlockStack gap="600">
                <div className={styles.Custom_Heading__Skeleton}>
                    <BlockStack gap="100">
                        <SkeletonDisplayText size="small" />
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </div>
                <BlockStack gap="500">
                    <div className={styles.Custom_Callout__CardSkeleton}>
                        <Card roundedAbove="sm">
                            <BlockStack gap="200">
                                <div className={styles.custom_callout_badge_skelton}>
                                    <SkeletonDisplayText size="small" />
                                </div>
                                <BlockStack gap="100">
                                    <SkeletonDisplayText size="small" />
                                    <SkeletonBodyText lines={1} />
                                </BlockStack>
                                <div className={styles.custom_callout_badge_skelton}>
                                    <SkeletonDisplayText size="small" />
                                </div>
                            </BlockStack>
                        </Card>
                    </div>
                    <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }}>
                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                            <BlockStack gap="500">
                                <div className={styles.Custom_Action__Skeleton}>
                                    <Card roundedAbove='sm'>
                                        <BlockStack gap="300">
                                            <SkeletonDisplayText size="small" />
                                            <SkeletonBodyText lines={2} />
                                            <BlockStack gap="200">
                                                <SkeletonTabs count={3} />
                                                <Card>
                                                    <div className={styles.Custom_ActionTaken__Skeleton}>
                                                        <BlockStack gap="400">
                                                            <BlockStack gap="500">
                                                                <InlineStack blockAlign='center' align='space-between'>
                                                                    <InlineStack gap="200" blockAlign='start'>
                                                                        <SkeletonThumbnail size="extraSmall" />
                                                                        <SkeletonBodyText lines={2} />
                                                                    </InlineStack>
                                                                    <SkeletonThumbnail size="medium" />
                                                                </InlineStack>
                                                                <InlineStack blockAlign='center' align='space-between'>
                                                                    <InlineStack gap="200" blockAlign='start'>
                                                                        <SkeletonThumbnail size="extraSmall" />
                                                                        <SkeletonBodyText lines={2} />
                                                                    </InlineStack>
                                                                    <SkeletonThumbnail size="medium" />
                                                                </InlineStack>
                                                                <InlineStack blockAlign='center' align='space-between'>
                                                                    <InlineStack gap="200" blockAlign='start'>
                                                                        <SkeletonThumbnail size="extraSmall" />
                                                                        <SkeletonBodyText lines={2} />
                                                                    </InlineStack>
                                                                    <SkeletonThumbnail size="medium" />
                                                                </InlineStack>
                                                                <InlineStack blockAlign='center' align='space-between'>
                                                                    <InlineStack gap="200" blockAlign='start'>
                                                                        <SkeletonThumbnail size="extraSmall" />
                                                                        <SkeletonBodyText lines={2} />
                                                                    </InlineStack>
                                                                    <SkeletonThumbnail size="medium" />
                                                                </InlineStack>
                                                            </BlockStack>
                                                        </BlockStack>
                                                    </div>
                                                </Card>
                                            </BlockStack>
                                        </BlockStack>
                                    </Card>
                                </div>
                                <div className={styles.Custom_Action__Skeleton}>
                                    <Card roundedAbove='sm'>
                                        <BlockStack gap="300">
                                            <SkeletonDisplayText size="small" />
                                            <SkeletonBodyText lines={2} />
                                            <Card>
                                                <div className={styles.Custom_ActionTaken__Skeleton}>
                                                    <BlockStack gap="600">
                                                        <InlineStack gap="200" blockAlign='start'>
                                                            <SkeletonThumbnail size="extraSmall" />
                                                            <SkeletonBodyText lines={3} />
                                                        </InlineStack>
                                                        <InlineStack gap="200" blockAlign='start'>
                                                            <SkeletonThumbnail size="extraSmall" />
                                                            <SkeletonBodyText lines={3} />
                                                        </InlineStack>
                                                        <InlineStack gap="200" blockAlign='start'>
                                                            <SkeletonThumbnail size="extraSmall" />
                                                            <SkeletonBodyText lines={3} />
                                                        </InlineStack>
                                                    </BlockStack>
                                                </div>
                                            </Card>
                                        </BlockStack>
                                    </Card>
                                </div>
                                <div className={styles.Custom_ProductList__Skeleton}>
                                    <Card roundedAbove='sm'>
                                        <BlockStack gap="200">
                                            <div className={styles.Custom_ProductHeading__Skeleton}>
                                                <InlineStack gap="300" blockAlign='center'>
                                                    <SkeletonDisplayText size="small" />
                                                    <SkeletonDisplayText size="medium" />
                                                </InlineStack>
                                            </div>
                                            <BlockStack gap="200">
                                                <Divider />
                                                <BlockStack gap="300">
                                                    <BlockStack gap="300">
                                                        <BlockStack gap="300">
                                                            <BlockStack gap="200">
                                                                <div className='Custom__Heading--Skeleton'>
                                                                    <InlineStack gap="200" align="space-between">
                                                                        <SkeletonBodyText lines={1} />
                                                                        <SkeletonBodyText lines={1} />
                                                                    </InlineStack>
                                                                </div>
                                                                <SkeletonBodyText lines={2} />
                                                            </BlockStack>
                                                            <Card>
                                                                <BlockStack gap={"500"}>
                                                                    <Grid columns={{ xs: 2, sm: 2, md: 4, lg: 4, xl: 4 }}>
                                                                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                            <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                                <SkeletonThumbnail size="extraSmall" />
                                                                                <SkeletonBodyText lines={2} />
                                                                            </InlineStack>
                                                                        </Grid.Cell>
                                                                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                            <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                                <SkeletonThumbnail size="extraSmall" />
                                                                                <SkeletonBodyText lines={2} />
                                                                            </InlineStack>
                                                                        </Grid.Cell>
                                                                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                            <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                                <SkeletonThumbnail size="extraSmall" />
                                                                                <SkeletonBodyText lines={2} />
                                                                            </InlineStack>
                                                                        </Grid.Cell>
                                                                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                            <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                                <SkeletonThumbnail size="extraSmall" />
                                                                                <SkeletonBodyText lines={2} />
                                                                            </InlineStack>
                                                                        </Grid.Cell>
                                                                    </Grid>
                                                                    <Grid columns={{ xs: 2, sm: 2, md: 4, lg: 4, xl: 4 }}>
                                                                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                            <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                                <SkeletonThumbnail size="extraSmall" />
                                                                                <SkeletonBodyText lines={2} />
                                                                            </InlineStack>
                                                                        </Grid.Cell>
                                                                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                            <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                                <SkeletonThumbnail size="extraSmall" />
                                                                                <SkeletonBodyText lines={2} />
                                                                            </InlineStack>
                                                                        </Grid.Cell>
                                                                    </Grid>
                                                                </BlockStack>
                                                            </Card>
                                                        </BlockStack>
                                                        <Divider />
                                                        <BlockStack gap="300">
                                                            <BlockStack gap="200">
                                                                <div className='Custom__Heading--Skeleton'>
                                                                    <InlineStack gap="200" align="space-between">
                                                                        <SkeletonBodyText lines={1} />
                                                                        <SkeletonBodyText lines={1} />
                                                                    </InlineStack>
                                                                </div>
                                                                <SkeletonBodyText lines={2} />
                                                            </BlockStack>
                                                            <Card>
                                                                <Grid columns={{ xs: 2, sm: 2, md: 4, lg: 4, xl: 4 }}>
                                                                    <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                        <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                            <SkeletonThumbnail size="extraSmall" />
                                                                            <SkeletonBodyText lines={2} />
                                                                        </InlineStack>
                                                                    </Grid.Cell>
                                                                    <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                        <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                            <SkeletonThumbnail size="extraSmall" />
                                                                            <SkeletonBodyText lines={2} />
                                                                        </InlineStack>
                                                                    </Grid.Cell>
                                                                    <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                        <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                            <SkeletonThumbnail size="extraSmall" />
                                                                            <SkeletonBodyText lines={2} />
                                                                        </InlineStack>
                                                                    </Grid.Cell>
                                                                    <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                        <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                            <SkeletonThumbnail size="extraSmall" />
                                                                            <SkeletonBodyText lines={2} />
                                                                        </InlineStack>
                                                                    </Grid.Cell>
                                                                </Grid>
                                                            </Card>
                                                        </BlockStack>
                                                    </BlockStack>
                                                </BlockStack>
                                            </BlockStack>
                                        </BlockStack>
                                    </Card>
                                </div>
                                <div className={styles.Custom_ProductList__Skeleton}>
                                    <Card roundedAbove='sm'>
                                        <BlockStack gap="200">
                                            <div className={styles.Custom_ProductHeading__Skeleton}>
                                                <InlineStack gap="300" blockAlign='center'>
                                                    <SkeletonDisplayText size="small" />
                                                    <SkeletonDisplayText size="medium" />
                                                </InlineStack>
                                            </div>
                                            <BlockStack gap="200">
                                                <Divider />
                                                <BlockStack gap="300">
                                                    <BlockStack gap="300">
                                                        <SkeletonBodyText lines={2} />
                                                        <Card>
                                                            <Grid columns={{ xs: 2, sm: 2, md: 4, lg: 4, xl: 4 }}>
                                                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                    <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                        <SkeletonThumbnail size="extraSmall" />
                                                                        <SkeletonBodyText lines={2} />
                                                                    </InlineStack>
                                                                </Grid.Cell>
                                                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                    <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                        <SkeletonThumbnail size="extraSmall" />
                                                                        <SkeletonBodyText lines={2} />
                                                                    </InlineStack>
                                                                </Grid.Cell>
                                                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                    <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                        <SkeletonThumbnail size="extraSmall" />
                                                                        <SkeletonBodyText lines={2} />
                                                                    </InlineStack>
                                                                </Grid.Cell>
                                                                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} >
                                                                    <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                                        <SkeletonThumbnail size="extraSmall" />
                                                                        <SkeletonBodyText lines={2} />
                                                                    </InlineStack>
                                                                </Grid.Cell>
                                                            </Grid>
                                                        </Card>
                                                    </BlockStack>
                                                </BlockStack>
                                            </BlockStack>
                                        </BlockStack>
                                    </Card>
                                </div>
                            </BlockStack>
                        </Grid.Cell>
                        <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                            <BlockStack gap="500">
                                <div className={styles.Custom_Feature__Skeleton}>
                                    <Card roundedAbove='sm'>
                                        <BlockStack gap="500">
                                            <BlockStack gap="200">
                                                <SkeletonThumbnail size="large" />
                                                <SkeletonDisplayText size="medium" />
                                                <SkeletonDisplayText size="medium" />
                                                <SkeletonBodyText lines={4} />
                                            </BlockStack>
                                            <SkeletonDisplayText size="medium" />
                                        </BlockStack>
                                    </Card>
                                </div>
                                <Card roundedAbove='sm'>
                                    <BlockStack gap="400">
                                        <BlockStack gap="200">
                                            <div className={styles.Custom_pricing_overview_skelton}>
                                                <InlineStack wrap={false} gap="200" align='space-between'>
                                                    <SkeletonDisplayText size='small' />
                                                    <SkeletonDisplayText size='small' />
                                                </InlineStack>
                                            </div>
                                            <SkeletonBodyText lines={2} />
                                        </BlockStack>
                                        <Card>
                                            <BlockStack gap="100">
                                                <BlockStack gap="500">
                                                    <SkeletonBodyText lines={2} />
                                                    <SkeletonBodyText lines={1} />
                                                    <SkeletonBodyText lines={2} />
                                                </BlockStack>
                                            </BlockStack>
                                        </Card>
                                    </BlockStack>
                                </Card>
                                <Card roundedAbove='sm'>
                                    <div className={styles.Custom_tour_overview_skelton}>
                                        <BlockStack gap={"300"}>
                                            <SkeletonDisplayText size='small' />
                                            <BlockStack gap="400">
                                                <InlineStack gap={"1000"} align='space-between' wrap={false}>
                                                    <SkeletonBodyText lines={6} />
                                                    <SkeletonThumbnail size="large" />
                                                </InlineStack>
                                                <SkeletonDisplayText size="medium" />
                                            </BlockStack>
                                        </BlockStack>
                                    </div>
                                </Card>
                                <Card roundedAbove='sm'>
                                    <BlockStack gap="400">
                                        <BlockStack gap="200">
                                            <InlineStack wrap={false} gap="200" align='space-between'>
                                                <SkeletonBodyText lines={1} />
                                                <SkeletonBodyText lines={1} />
                                            </InlineStack>
                                            <SkeletonBodyText lines={2} />
                                        </BlockStack>
                                        <Card>
                                            <BlockStack gap="100">
                                                <BlockStack gap="500">
                                                    <SkeletonBodyText lines={2} />
                                                    <SkeletonBodyText lines={2} />
                                                </BlockStack>
                                            </BlockStack>
                                        </Card>
                                    </BlockStack>
                                </Card>
                            </BlockStack>
                        </Grid.Cell>
                    </Grid>
                </BlockStack>
            </BlockStack>
        </Page>
    );
}

export default OverviewSkeleton;